
function AssistantTooltip () {
    this.element = document.querySelector('.assistant-tooltip');
    this.backdrop = document.querySelector('.assistant-tooltip-backdrop');
    this.button = document.querySelector('.assistant-tooltip-button');
    this.exitButton = document.querySelector('.assistant-tooltip-exit');

    this.expanded = false;

    this.onClick = function () {
        this.expanded = !this.expanded;

        try {
            if (this.expanded) {
                window.FB.CustomerChat.hide();
            } else {
                window.FB.CustomerChat.show(false);
            }
        } catch (e) {}

        const expandedValue = this.expanded ? '0%' : '100%';
        this.element.style.transform = 'translateX(' + expandedValue + ')';
        this.backdrop.style.opacity = this.expanded ? '0' : '1';
        this.backdrop.style.display = this.expanded ? 'block' : 'none';
        this.backdrop.style.opacity = this.expanded ? '1' : '0';
        document.body.style.overflow = this.expanded ? 'hidden' : 'auto';
    }
    this.init = () => {
        this.button.addEventListener('click', this.onClick.bind(this));
        this.backdrop.addEventListener('click', this.onClick.bind(this));
        this.exitButton.addEventListener('click', this.onClick.bind(this));
    };
    this.init();
}

window.addEventListener('DOMContentLoaded', () => {
    new AssistantTooltip();
});
